exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._378AqQXt7Vn66ek8Mf4Fo5:before,._1oljQ_DrOXahEd4Ul19wCj{color:\"[theme:redDark, default:#a80000]\"!important}._32S8K94lku5ujN8zmSd9ED:before{color:\"[theme:green20, default:#0b6a0b]\"!important}html[dir] ._32S8K94lku5ujN8zmSd9ED:before{margin-bottom:2px}.FrbQICt3iaACzrHrfGzBs{color:\"[theme:green20, default:#0b6a0b]\"!important}._3Y1jo0XOp_HAd3rW6--a2L:before,._2j8V1xp5Mp1bYxkpMKFOZB{color:\"[theme:themePrimary, default:#0078D4]\"!important}._3K512Ld4FHiESFMYdEMLkE:before{color:\"[theme:themePrimary, default:#0078D4]\"}", ""]);
// Exports
exports.locals = {
	"redDark": "_378AqQXt7Vn66ek8Mf4Fo5",
	"redDarkNext": "_1oljQ_DrOXahEd4Ul19wCj",
	"snooze": "_32S8K94lku5ujN8zmSd9ED",
	"snoozeNext": "FrbQICt3iaACzrHrfGzBs",
	"accounts": "_3Y1jo0XOp_HAd3rW6--a2L",
	"accountsNext": "_2j8V1xp5Mp1bYxkpMKFOZB",
	"accountsRead": "_3K512Ld4FHiESFMYdEMLkE"
};